import { StorageCountVerdict } from '@navio/nsdk';
import { NoddiIcon } from 'noddi-ui-common';
import { NoddiBadge } from 'noddi-ui-web';
import { STORAGE_COUNT_VERDICT_LABEL_MAP } from 'noddi-util';
import { STORAGE_COUNT_VERDICT_ICON } from './StorageCountStatusIcon';

const VARIANT_BY_VERDICT = {
  [StorageCountVerdict.MATCH]: 'success',
  [StorageCountVerdict.WRONG_UNIT]: 'warning',
  [StorageCountVerdict.MISSING]: 'destructive',
  [StorageCountVerdict.UNEXPECTED]: 'warning',
  [StorageCountVerdict.MOVED_OUT]: 'outline'
} as const;

type Props = {
  verdict: StorageCountVerdict | null | undefined;
};

export const StorageCountVerdictBadge = ({ verdict }: Props) => {
  if (verdict == null) {
    return <NoddiBadge variant='outline'>Pending</NoddiBadge>;
  }

  return (
    <NoddiBadge variant={VARIANT_BY_VERDICT[verdict]}>
      <NoddiIcon name={STORAGE_COUNT_VERDICT_ICON[verdict]} size='small' />
      {STORAGE_COUNT_VERDICT_LABEL_MAP[verdict]}
    </NoddiBadge>
  );
};
